module.exports = __webpack_public_path__ + "img/arrow_right.e8a21e66.svg";